module.exports = __webpack_public_path__ + "static/img/no-equip.f0d241b8.png";